import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as f from './_cmFTH';
import * as cr from './_cr';

import * as gs from "./_csGbl";
import * as ls from "./_csLcl";
import { a } from "./_csAbt";

import * as BoxC from './_ccbBoxC';
import * as BtnCttC from './_ccmBtnCttC';
import * as GridC from './_cccGridC';
import * as IptC from './_ccbIptC';
import * as LblC from './_cccLblC';

import * as ica from 'src/ica';
import * as ihd from 'src/ihd';

import * as _cv_51 from './_cv_51___Mz';

let $_51z = _cv_51.itl_51z();

export const B = (pz: ht.btnCttCz) => {
  return (
    cr.c(BtnCttC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
        ugdAsync: async () => {
          const _51z = await _cv_51.save_51rDzAsync({
            ... pz,
            _51z: $_51z,
          });
          return {
            _50r_icn: _51z._51rz._icn,
          };
        }
      }
    })
  );
};

export const D = (pz: ht.viewDtlCz & {
  cz: {
    _31r_fst: ht.n,
  }
}) => {

//  const _gUserz = gs.useUserz();
  const _frcUdt = ls.frcUdt();

  React.useEffect(() => {
    f.loadAllAsync({
      frcUdt: _frcUdt,
      bfrAsync: () => [
        _cv_51.load_51rDzAsync({
//          _31r_fst: _gUserz.crt._31rz._fst,
          _31r_fst: pz.cz._31r_fst,
          _50r_icn: pz.sPz.crt._50r_icn,
          //cdn: pz.cz?.cdn,
          vsn: pz.sPz.crt.vsn,
        })
        .then((_dz: ht.dz) => {
          $_51z = _dz;
        })
      ],
    });
  }, [
    pz.sPz.crt.phs,
    pz.sPz.crt._50r_icn,
    pz.cz?.cdn,
    pz.sPz.crt.vsn,
  ])

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewDtlAbtz[_abtType] ? ica.viewDtlAbtz[_abtType]() : {};

  //hf.l(`51b 70: ${$_51z?._50rz._icn}, ${$_51z?._50rz._50rt1100s}, ${$_51z._50rz._50rt1100s == 'InpS'}, ${$_51z?._51rz._51ra1100t}, ${$_51z?._50rz._50ra1100t}`);

  return (
    cr.c(BoxC.N, {
      key: -10,
      boxStlz: a('dw/f fd/csc'),
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'nolineCmnz',
//          boxStlz: a('dwx/60 mb/2 mh/a'),
          boxStlz: a('dw/f dwx/80'),
          lineCs: [
            {
              boxStlz: a('f/n mb/1'),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: '設定分類',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: false,
                              iptType: 'text',
                              vle: $_51z?._50rz._50rc1100s ?? '',
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a('f/n mb/1'),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: '設定項目ID',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: false,
                              iptType: 'text',
                              vle: $_51z?._50rz._icn ?? '',
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a('f/n mb/1'),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: '設定項目名',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: false,
                              iptType: 'text',
                              vle: $_51z?._50rz._pfx ?? '',
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a('f/n mb/1'),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: '適用範囲',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: false,
                              iptType: 'text',
                              vle: ihd.r(ihd.f('_50rt2100i').ls, $_51z?._50rz._50rt2100i ?? 10),
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a('f/n mb/1'),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      boxStlz: a('fd/rss'),
                      lblCz: {
                        textz: {
                          pfx: '設定値',
                        }
                      },
                      cttCz: {
                        oClds: [
                          hf.i($_51z._50rz._50rt1100s, ['InpS', 'Scr']) ?
                          cr.c(IptC.S, {
                            key: -10,
//                            boxStlz: a('sc/rd5'),
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              bScr: $_51z._50rz._50rt1100s == 'Scr' ? true : false,
                              iptType: 'text',
                              vle: $_51z?._51rz._51ra1100t ?? $_51z?._50rz._50ra1100t,
                              onChg: ( _s: ht.s ) => {
                                $_51z._51rz._51ra1100t = _s;
                                //hf.l(`_cv_51b 203: ${hf.s($_51z)}`)
                              },
                            }
                          })
                          : null,
                          $_51z._50rz._50rt1100s == 'InpM' ?
                          cr.c(IptC.S, {
                            key: -20,
                            boxStlz: a('dh/30 dw/f'),
                            iptStlz: {
                              showz: a(`dh/f`),
                              editz: a(`dh/f`),
                            },
                            iptPtyz: a(`tm`),
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $_51z?._51rz._51ra1100t ?? $_51z?._50rz._50ra1100t,
                              onChg: ( _s: ht.s ) => {
                                $_51z._51rz._51ra1100t = _s;
                                //hf.l(`_cv_51b 220: ${hf.s($_51z)}`)
                              },
                            }
                          })
                          : null,
                          $_51z._50rz._50rt1100s == 'Pcr' ?
                          cr.c(IptC.S, {
                            key: -30,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'pcr',
                              ls: hf.j($_51z?._50rz._50ra3100j),
                              vle: $_51z?._51rz._51ra1100t ?? $_51z?._50rz._50ra1100t,
                              onChg: ( _dz: ht.dz ) => {
                                $_51z._51rz._51ra1100t = _dz.key;
                                //hf.l(`_cv_51b 235: ${hf.s($_51z)}`)
                              },
                            }
                          })
                          : null,
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
          ]
        }),

      ]
    })
  );
};

